import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import type { SelectedDrug } from '../models/drug.model';
import { type DrugInContext, StateAction } from '../models/ui.model';

@Injectable({
  providedIn: 'root'
})
export class DrugSelectionContext {
  private readonly _drugInContext$ = new BehaviorSubject<DrugInContext | null>(null);

  getDrugInContext$(): Observable<DrugInContext | null> {
    return this._drugInContext$.asObservable();
  }

  setDrugInContext(selectedDrug: SelectedDrug, action: StateAction): void {
    this._drugInContext$.next({ selectedDrug, action });
  }

  clearContext(): void {
    this._drugInContext$.next(null);
  }
}
